import { render } from "./FireEmployee.vue?vue&type=template&id=e41d1d5c&scoped=true"
import script from "./FireEmployee.vue?vue&type=script&lang=js"
export * from "./FireEmployee.vue?vue&type=script&lang=js"

import "./FireEmployee.vue?vue&type=style&index=0&id=e41d1d5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e41d1d5c"]])

export default __exports__